import { linkify } from 'helpers/linkify';
import { classNames, React, useLayoutEffect, useMemo, useRef, useState } from 'libs/react';
import './ActivityText.scss';
/**
 * @component ActivityText
 * @since 1.0.0
 * Body of a note or reminder: clickable links, long text folded after a few
 * lines with a "show more" toggle.
 */
export function ActivityText(props) {
    const { value } = props;
    const ref = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [overflowing, setOverflowing] = useState(false);
    const nodes = useMemo(() => linkify(value), [value]);
    useLayoutEffect(() => {
        const node = ref.current;
        if (node && !expanded) {
            setOverflowing(node.scrollHeight > node.clientHeight + 1);
        }
    }, [value, expanded]);
    return (React.createElement("div", { className: classNames('activity-text', props.className) },
        React.createElement("p", { ref: ref, className: classNames('activity-text-value', {
                'activity-text-value--clamped': !expanded
            }) }, nodes),
        (overflowing || expanded) && (React.createElement("button", { type: "button", className: "activity-text-toggle", onClick: () => setExpanded(!expanded) }, expanded ? t('Show less') : t('Show more')))));
}
